import { globalActions } from '../../global-actions';

export const actionTypes = {
  SET_PUSH_NOTIFICATION_IN_DIALOG_SHOW: 'SET_PUSH_NOTIFICATION_IN_DIALOG_SHOW',
  SET_INJECTED_HP: 'SET_INJECTED_HP',
  SET_INJECTED_HP_IN_VIEW: 'SET_INJECTED_HP_IN_VIEW',
  SET_VIDEO_CAROUSEL_STATUS: 'SET_VIDEO_CAROUSEL_STATUS',
  SET_PLAYERS_ON_PAGE: 'SET_PLAYERS_ON_PAGE',
};

export const actions = {
  setPushNotificationInDialogShow: (isPushNotificationShown) => {
    globalActions.next({
      type: actionTypes.SET_PUSH_NOTIFICATION_IN_DIALOG_SHOW,
      payload: { isPushNotificationShown },
    });
  },
  setInjectedHP: (isInjectedHP) => {
    globalActions.next({
      type: actionTypes.SET_INJECTED_HP,
      payload: { isInjectedHP },
    });
  },
  setInjectedHPInView: (isInjectedHPInView) => {
    globalActions.next({
      type: actionTypes.SET_INJECTED_HP_IN_VIEW,
      payload: { isInjectedHPInView },
    });
  },
  setVideoCarouselStatus: (videoCarouselStatus) => {
    globalActions.next({
      type: actionTypes.SET_VIDEO_CAROUSEL_STATUS,
      payload: { videoCarouselStatus },
    });
  },
  setPlayersOnPage: (playersOnPage) => {
    globalActions.next({
      type: actionTypes.SET_PLAYERS_ON_PAGE,
      payload: { playersOnPage },
    });
  },
};
